import { App, Button, Dropdown, Popconfirm, Popover, Space } from 'antd';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import {
  deleteModeOfPayment,
  getModeOfPayments,
} from '../../network/ModeOfPayments';
import { useNavigate } from 'react-router-dom';
import StatusTag from '../../hooks/StatusHook';
import DashboardCards from '../Dashboard/DashboardCards';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import { DeleteOutlined } from '@ant-design/icons';
const ModeOfPaymentsTable = ({ t }) => {
  const client = useQueryClient();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const [searchText, setSearchText] = useState('');
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getModeOfPayments],
    queryFn: () => getModeOfPayments(),
    keepPreviousData: true,
  });
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deleteModeOfPayment(id),
      onSuccess: (data) => {
        // console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message?.message);
        client.invalidateQueries({
          queryKey: [queryKeys.getModeOfPayments],
        });
      },
    }
  );
  const items = (record) => [
    {
      key: '1',
      label: t.edit + ' ' + t.ModeofPayment,
      icon: <MdModeEditOutline />,
      onClick: () => {
        navigate(`/modeofpayments/${record.name}`);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.DeletetheModeofPayment}
          description={t.areYouSure}
          onConfirm={() => handleRemove.mutate(record.name)}
          // onCancel={cancel}
          okText={t.yes}
          cancelText={t.no}
        >
          <span style={{ color: 'red' }}>
            {t.Delete} {t.ModeofPayment}
          </span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.ModeofPayment,
      dataIndex: 'name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record.mode_of_payment).toLowerCase();
        const searchValue = value.toLowerCase();
        return name.includes(searchValue);
      },
    },
    {
      title: t.type,
      dataIndex: 'type',
    },
    {
      title: t.enabled,
      dataIndex: 'enabled',
      render: (text, record) => {
        return <StatusTag status={record?.enabled ? 'Yes' : 'No'} />;
      },
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 100,
      render: (text, record) => {
        // console.log('record:', record);
        return (
          <Space>
            {/* <Popover
              placement="top"
              title={t.edit}
              onClick={() => navigate(`/modeofpayments/${record.name}`)}
            >
              <Button size="small" type="primary">
                <MdModeEditOutline />
              </Button>
            </Popover>
            <Popconfirm
              title={t.DeletetheModeofPayment}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record.name)}
              // onCancel={cancel}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger>
                <MdDelete />
              </Button>
            </Popconfirm> */}
            <Dropdown
              menu={{ items: items(record) }}
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      ...item,
      key: index,
    };
  });
  return (
    <div className="mode-of-payments">
      {/* <Heading title={t.dashboard} subTitle={t.ModeofPayment} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          titleBtn={t.AddModeOfPayment}
          // Placeholder={t.Search}
          pathBtn="/modeofpayments/add"
        />
      </div>
    </div>
  );
};

export default ModeOfPaymentsTable;
